"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRegExp = exports.stringLiteral = exports.concatStringLiteral = exports.toStringOrRegExp = exports.pythonLanguage = void 0;
exports.pythonLanguage = {
    toParameterTypeName: function (node) {
        switch (node.type) {
            case 'string': {
                return stringLiteral(node.text);
            }
            case 'concatenated_string': {
                return concatStringLiteral(node.text);
            }
            case 'identifier': {
                return node.text;
            }
            default: {
                throw new Error("Unsupported node type ".concat(node.type));
            }
        }
    },
    toParameterTypeRegExps: function (node) {
        switch (node.type) {
            case 'string':
            case 'identifier': {
                return RegExp(cleanRegExp(stringLiteral(node.text)));
            }
            case 'concatenated_string': {
                return RegExp(cleanRegExp(concatStringLiteral(node.text)));
            }
            default: {
                throw new Error("Unsupported node type ".concat(node.type));
            }
        }
    },
    toStepDefinitionExpression: function (node) {
        return toStringOrRegExp(node.text);
    },
    defineParameterTypeQueries: [
        "(call\n      arguments: (argument_list\n        (keyword_argument\n          name: (identifier) @name-key\n          value: (string) @name\n          (#eq? @name-key \"name\")\n        )\n        (keyword_argument\n          name: (identifier) @regexp-key\n          value: (string) @expression\n          (#eq? @regexp-key \"regexp\")\n        )\n    )) @root",
        "(call\n      arguments: (argument_list\n        (keyword_argument\n          name: (identifier) @name-key\n          value: (string) @name\n          (#eq? @name-key \"name\")\n        )\n        (keyword_argument\n          name: (identifier) @regexp-key\n          value: (concatenated_string) @expression\n          (#eq? @regexp-key \"regexp\")\n        )\n    )) @root",
        "(call\n      arguments: (argument_list\n          (keyword_argument\n          name: (identifier) @regexp-key\n          value: (string) @expression\n          (#eq? @regexp-key \"regexp\")\n        )\n        (keyword_argument\n          name: (identifier) @name-key\n          value: (string) @name\n          (#eq? @name-key \"name\")\n        )\n    )) @root",
        "(call\n      arguments: (argument_list\n        (keyword_argument\n          name: (identifier) @regexp-key\n          value: (concatenated_string) @expression\n          (#eq? @regexp-key \"regexp\")\n        )\n        (keyword_argument\n          name: (identifier) @name-key\n          value: (string) @name\n          (#eq? @name-key \"name\")\n        )\n    )) @root",
    ],
    defineStepDefinitionQueries: [
        "(decorated_definition\n      (decorator\n        (call\n          function: (identifier) @method\n          arguments: (argument_list (string) @expression)\n        )\n      )\n      (#match? @method \"(given|when|then|step)\")\n    ) @root",
    ],
    snippetParameters: {
        int: { type: 'int' },
        float: { type: 'float' },
        word: { type: 'str' },
        string: { type: 'str' },
        double: { type: 'double' },
        bigdecimal: { type: 'decimal' },
        byte: { type: 'byte' },
        short: { type: 'short' },
        long: { type: 'long' },
        biginteger: { type: 'int' },
        '': { type: 'Object', name: 'arg' },
    },
    defaultSnippetTemplate: "\n@{{ #lowercase }}{{ keyword }}{{ /lowercase }}('{{ expression }}')\ndef step_{{ #lowercase }}{{ keyword }}{{ /lowercase }}(context{{ #parameters }}, {{ name }}{{ /parameters }}):\n    # This was autogenerated using Cucumber Expressions syntax.\n    # Please convert to use Regular Expressions, as Behave does not currently support Cucumber Expressions.",
};
function cleanRegExp(regExpString) {
    return regExpString.startsWith('/') ? regExpString.slice(1, -1) : regExpString;
}
function toStringOrRegExp(step) {
    var stepText = removePrefix(step, 'u');
    var strippedStepText = stepText.slice(1, -1);
    return isRegExp(strippedStepText)
        ? RegExp(cleanRegExp(strippedStepText.split('?P').join('')))
        : strippedStepText;
}
exports.toStringOrRegExp = toStringOrRegExp;
function concatStringLiteral(text) {
    return removePrefix(text, 'f')
        .split('\\\n')
        .map(function (x) { return x.replace(/"/g, ''); })
        .map(function (x) { return x.trim(); })
        .join('');
}
exports.concatStringLiteral = concatStringLiteral;
function stringLiteral(text) {
    return removePrefix(text, 'f').slice(1, -1);
}
exports.stringLiteral = stringLiteral;
function isRegExp(cleanWord) {
    var startsWithSlash = cleanWord.startsWith('/');
    var namedGroupMatch = /\?P/;
    var specialCharsMatch = /\(|\)|\.|\*|\\|\|/;
    var containsNamedGroups = namedGroupMatch.test(cleanWord);
    var containsSpecialChars = specialCharsMatch.test(cleanWord);
    return startsWithSlash || containsNamedGroups || containsSpecialChars;
}
exports.isRegExp = isRegExp;
function removePrefix(text, prefix) {
    return text.startsWith(prefix) ? text.slice(1) : text;
}
//# sourceMappingURL=pythonLanguage.js.map